import axios from 'axios';

export const api = axios.create();

export const entrataAPI = axios.create();

export const globalErrorHandler = (error, callback) => {
    console.log('error', error.response);

    if (callback && typeof callback === 'function') {
        switch (error.response.status) {
            case 401:
                callback('Looks like maybe your login expired. Try logging in again.', { appearance: 'error', autoDismiss: true });
                break;
            case 403:
                callback('That function requires different access.', { appearance: 'error', autoDismiss: true });
                break;
            case 500:
                callback('Something went wrong on the Server.', { appearance: 'error', autoDismiss: true });
                break;
            default:
                if (error.response.data) {
                    callback(error.response.data, { appearance: 'error', autoDismiss: true });
                }
                else {
                    callback(error.response.status + ' - ' + error.response.statusText || 'An error has occured!', { appearance: 'error', autoDismiss: true });
                }
        }
    }
};



// WEBPACK FOOTER //
// ./src/api/create-api.js